import { Outlet } from "react-router-dom";
import { CompetitionsProvider } from "../context/CompetitionsContext";

export function CompetitionsProviderWrapper() {
  return (
    <CompetitionsProvider>
      <Outlet />
    </CompetitionsProvider>
  );
}
